import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_HierarchyManagementHierarchyMasterForm = _resolveComponent("HierarchyManagementHierarchyMasterForm")
  const _component_HierarchyManagementHierarchyMasterSelectList = _resolveComponent("HierarchyManagementHierarchyMasterSelectList")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary hierarchy-dialog ",
    style: {"width":"70%"},
    visible: _ctx.visible,
    modal: true,
    closable: false,
    draggable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.hierarchyManagement.createHierarchyMaster')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: _ctx.saveButtonDisabled,
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_HierarchyManagementHierarchyMasterForm, { nodeGeneralFields: _ctx.nodeGeneralFields }, null, 8, ["nodeGeneralFields"]),
      _createVNode(_component_HierarchyManagementHierarchyMasterSelectList, {
        dimensionMetadata: _ctx.dimensionMetadata,
        onRecursiveChanged: _ctx.onRecursiveChanged,
        onLevelsChanged: _ctx.onLevelsChanged
      }, null, 8, ["dimensionMetadata", "onRecursiveChanged", "onLevelsChanged"])
    ]),
    _: 1
  }, 8, ["visible"]))
}